import crypto from "node:crypto";
import { BYTES_DIVISOR } from "@constants/onTestEnd";
export const getFileData = (file, contentType, filename) => {
    const byteSize = file.byteLength;
    const checksum = crypto
        .createHash("md5")
        .update(Uint8Array.from(file))
        .digest("base64");
    return { file, filename, checksum, byteSize, contentType };
};
export const generateFileName = (path, name, contentType) => {
    const fileName = path !== null && path !== void 0 ? path : `${name}.${contentType.split("/")[1]}`;
    return fileName.replaceAll("/", "-");
};
export const bytesToUnits = (bytes, unit) => parseFloat((bytes / BYTES_DIVISOR[unit]).toFixed(2));
export const calculateLowestUnit = (bytes) => bytes / 1024 > 1024 ? "MB" : "KB";
//# sourceMappingURL=fileHelpers.js.map